<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item href="#">学导跟进数据</Breadcrumb-item>
        <Breadcrumb-item>学生请假详情</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="search" @keyup.enter="search">
      <Form :label-width="60" :show-message="false">
        <Row :gutter="12">
          <Col :xs="12" :sm="8" :md="5">
          <Form-item label="学生ID" >
            <Input name="uid"
                   v-model="queryParam.uid"></Input>
          </Form-item>
          </Col>
          <Col :xs="12" :sm="8" :md="6" :offset="1">
          <Button type="primary" :loading="searchLoading" :disable="searchLoading" icon="search"
                  @click="search" >搜索</Button>
          </Col>
        </Row>
      </Form>
    </div>
    <List ref="dataList" :tableColumns="title" :reload="reload" listUrl="/bookUserLeaveTime/listTotalLeaveNum"
          :params="queryParam" :onLoading="onLoading"></List>
    <Modal width="980" title="涉及请假课程"
           v-model="showBookLessonOpenedModal" >
      <Table class="compact" size="small" :columns="bookLessonOpenedColumn" :data="bookLessonOpenedList"></Table>
      <div slot="footer" ></div>
    </Modal>
  </div>

</template>
<style>

</style>
<script>
  import StudentInfo from '../common/StudentInfo.vue'
import { fetchTchScoreMap, applyTchScoresToRows, renderTchNameWithScore } from '@/utils/tchScore'
  export default {
    data () {
      let $constant = this.$constant
      let $moment = this.$moment
      return {
        searchLoading: false,
        reload: 0,
        rankScoreSeq: 0,
        queryParam: {
          uid: '',
          studyAdviserId: '',
          userMobile: '',
          userNickname: '',
          adminNickname: '',
          adminMobile: '',
          startTimeDate: '',
          endTimeDate: '',
          startTime: '',
          endTime: ''
        },
        title: [
          {
            title: '学生ID、姓名',
            render: (h, params) => {
              let row = params.row

              return h(StudentInfo, {
                props: {
                  name: `${row.userNickname || ''}`,
                  uid: row.uid
                }
              })
            }
          },
          {
            title: '开始、结束时间',
            align: 'center',
            width: 150,
            render: (h, params) => {
              let startTime = params.row.startTime
              let endTime = params.row.endTime
              return h('span', $moment(startTime, 'X').format('YYYY-MM-DD HH:mm') + ' ' + $moment(endTime, 'X').format('YYYY-MM-DD HH:mm'))
            }
          },
          {
            title: '涉及课节',
            align: 'center',
            width: 84,
            render: (h, params) => {
              return h('div', [
                h('a', { on: { click: () => { this.onBookLessonOpened(params.row) } } }, '查看')
              ])
            }
          },
          {
            title: '操作人',
            key: 'adminNickname'
          },
          {
            title: '操作时间',
            align: 'center',
            width: 150,
            render: (h, params) => {
              let updateTime = params.row.updateTime
              return h('span', updateTime && $moment(updateTime, 'X').format('YYYY-MM-DD HH:mm:ss'))
            }
          },
          {
            title: '备注',
            key: 'remark'
          },
        ],
        showBookLessonOpenedModal: false,
        bookLessonOpenedColumn: [
          {
            title: '学生ID、姓名',
            width: 100,
            render: (h, params) => {
              let row = params.row
              return h('div', [
                h('span', row.uid),
                h('span', ' - '),
                h('span', row.userNickname || '')
              ])
            }
          },
          {
            title: '手机号码',
            align: 'center',
            width: 100,
            key: 'userMobile'
          },
          {
            title: '老师ID、姓名',
            width: 180,
            render: (h, params) => {
              let row = params.row
              return renderTchNameWithScore(h, {
                text: row.tchId + ' - ' + ((row.tchFirstName || '') + ' ' + (row.tchLastName || '')).trim(),
                score: row.monthRankScore
              })
            }
          },
          {
            title: '学顾',
            width: 90,
            key: 'studyAdviserNickname'
          },
          {
            title: '外教运营',
            width: 90,
            key: 'adviserNickname'
          },
          {
            title: '开始、结束时间',
            align: 'center',
            width: 122,
            render: (h, params) => {
              let lsnBeginTime = params.row.lsnBeginTime
              let lsnEndTime = params.row.lsnEndTime
              return h('span', $moment(lsnBeginTime, 'X').format('YYYY-MM-DD HH:mm') + ' ' + $moment(lsnEndTime, 'X').format('YYYY-MM-DD HH:mm'))
            }
          },
          {
            title: '上课类型',
            align: 'center',
            width: 72,
            render: (h, params) => {
              let lsnType = params.row.lsnType
              let typeEnum = $constant.getEnum($constant.bookLessonOpenedLsnType, lsnType)
              return h('span', typeEnum && typeEnum.text)
            }
          },
          {
            title: '课程名称',
            key: 'lessonTitle'
          },
          {
            title: '上课时长',
            align: 'center',
            width: 72,
            key: 'courseTime'
          },
          {
            title: '上课状态',
            width: 72,
            render: (h, params) => {
              let lsnSelStatus = params.row.lsnSelStatus
              let statusEnum = $constant.getEnum($constant.lsnSelStatus, lsnSelStatus)
              return h('span', statusEnum && statusEnum.text)
            }
          }
        ],
        bookLessonOpenedList: []
      }
    },
    mounted: function () {
    },
    created: function () {
      this.queryParam.studyAdviserId = localStorage.studyAdviserId
      this.queryParam.startTimeSec = localStorage.startTime
      this.queryParam.endTimeSec = localStorage.endTime
    },
    methods: {
      search () {
        this.reload = new Date().getTime()
      },
            onLoading (loading) {
        this.searchLoading = loading
        if (!loading) {
          this.loadMonthRankScores()
        }
      },
      loadMonthRankScores () {
        const table = this.$refs.dataList && this.$refs.dataList.tableData
        if (!table || !table.length) {
          return
        }
        const ids = table.map(function (row) { return row.tchId }).filter(function (id) { return id != null })
        const seq = ++this.rankScoreSeq
        const self = this
        fetchTchScoreMap(this.$http, ids).then(function (map) {
          if (seq !== self.rankScoreSeq) {
            return
          }
          applyTchScoresToRows(self, table, 'tchId', 'monthRankScore', map)
        })
      },
      startTimeDateChange (value) {
        this.queryParam.startTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X')
      },
      endTimeDateChange (value) {
        this.queryParam.endTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X')
      },
      onBookLessonOpened (row) {
        let self = this
        let params = {}
        params.uid = row.uid
        params.startTime = row.startTime
        params.endTime = row.endTime

        self.$http.get('/bookLesson/userLeave/list', { params: params }).then(function (res) {
          self.showBookLessonOpenedModal = true
          self.bookLessonOpenedList = res.data
        })
      },
    }
  }

</script>



// WEBPACK FOOTER //
// ShowTotalLeaveDetail.vue?6b7e829c